import React from 'react';

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M26.1514 26.5L19.2399 19.5885M1.15137 12.0516C1.15137 13.4373 1.42429 14.8094 1.95456 16.0896C2.48483 17.3697 3.26206 18.5329 4.24186 19.5128C5.22167 20.4926 6.38487 21.2698 7.66506 21.8001C8.94524 22.3303 10.3173 22.6033 11.703 22.6033C13.0886 22.6033 14.4607 22.3303 15.7409 21.8001C17.0211 21.2698 18.1843 20.4926 19.1641 19.5128C20.1439 18.5329 20.9211 17.3697 21.4514 16.0896C21.9817 14.8094 22.2546 13.4373 22.2546 12.0516C22.2546 10.666 21.9817 9.29388 21.4514 8.0137C20.9211 6.73351 20.1439 5.57031 19.1641 4.5905C18.1843 3.61069 17.0211 2.83346 15.7409 2.30319C14.4607 1.77293 13.0886 1.5 11.703 1.5C10.3173 1.5 8.94524 1.77293 7.66506 2.30319C6.38487 2.83346 5.22167 3.61069 4.24186 4.5905C3.26206 5.57031 2.48483 6.73351 1.95456 8.0137C1.42429 9.29388 1.15137 10.666 1.15137 12.0516Z"
        stroke="#FEFEFE"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;